/**
  * ADVANCED USE ONLY! USE (AND BREAK) AT YOUR OWN RISK!
  * Use this hook if you need to override how slidesHTML is created/output.
  * By default, the hook is set to null and ignored.
  * To use the hook, copy the contents of the identically named INF file here, then modify as desired.
  * If you need to import any infinite JS modules, the base path from here is: '../../../../../../../@infinite/scripts/'
*/

export default null;